module.exports = __webpack_public_path__ + "static/img/logo.d36c5935.png";